import * as z from "zod";

export const getAppEmbedStatus = {
  name: "getAppEmbedStatus" as const,
  input: z.object({}),
  output: z.object({ enabled: z.boolean(), checkFailed: z.boolean() }),
};
